import { List, TextField, EditButton, SimpleList, Datagrid, TopToolbar, CreateButton } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { IntermediaryExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListIntermediary = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={IntermediaryExporter} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Представители"
      sx={settings.style.expandStyle}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateIntermediaries)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              fields={[
                { label: "Име на фирмата", value: record.companyName },
                { label: "Лице за контакт", value: record.personName },
                { label: "Телефон", value: record.phoneNumber },
                { label: "Имейл", value: record.email },
              ]}
            />
          )}
          tertiaryText={record => (
            <>{checkPermission(userPermissions, permissions.canUpdateIntermediaries) && <EditButton label="" />}</>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="companyName"
            label="Име на фирмата"
            sortable={false}
          />
          <TextField
            source="personName"
            label="Лице за контакт"
            sortable={false}
          />
          <TextField
            source="phoneNumber"
            label="Телефон"
            sortable={false}
          />
          <TextField
            source="email"
            label="Имейл"
            sortable={false}
          />
          {checkPermission(userPermissions, permissions.canUpdateIntermediaries) && <EditButton />}
        </Datagrid>
      )}
    </List>
  );
};
export default ListIntermediary;
